import React from 'react';

import Message from '../common/message/Message';

export const ProgText = props => <Message as="p" {...props} />;
